import React, { useEffect, useState } from 'react';
// replace:
import { Table, Button, Drawer, Space, Popconfirm, Card, Typography, Descriptions, Segmented, Input, Row, Col, Form, Select, DatePicker, Divider, Tooltip, Dropdown, Menu } from 'antd';
import customParseFormat from "dayjs/plugin/customParseFormat";
import {
  PlusOutlined, EditOutlined, DeleteOutlined, EyeOutlined, EyeInvisibleOutlined,
  FileTextOutlined, CalendarOutlined, LineChartOutlined, TeamOutlined,
  FireOutlined, FileDoneOutlined, TrophyOutlined, DollarOutlined,
  ClockCircleOutlined, ExclamationCircleOutlined, PhoneOutlined, DownOutlined, DownloadOutlined
} from '@ant-design/icons';
import useMessage from 'antd/es/message/useMessage';
import CreateEnquiry from '../../components/Manage/Enquiry/CreateEnquiry';
import { ServicetypeService } from '../../Services/Manage/ServicetypeService';
import { EnquiryService } from '../../Services/Manage/EnquiryService';
import dayjs from 'dayjs';
import { UserService } from '../../Services/Manage/UserService';
import { useNavigate } from 'react-router-dom';

import utc from 'dayjs/plugin/utc';
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import isBetween from "dayjs/plugin/isBetween";
import DashboardSummary from "./DashboardSummary";
import { AddEmployeesService } from '../../Services/Manage/AddEmployeesService';
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip as RechartsTooltip } from 'recharts';
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';


dayjs.extend(utc);

dayjs.extend(customParseFormat);

// replace:
const getPermission = (link) => {
  try {
    const raw = localStorage.getItem("ome_permission");
    const parsed = JSON.parse(raw);
    const permissions = Array.isArray(parsed) ? parsed : JSON.parse(parsed);
    return permissions.find(p => p.link === link) || { add: false, edit: false, delete: false, read: false };
  } catch { return { add: false, edit: false, delete: false, read: false }; }
};

const EnquiryPage = () => {
  const perm = getPermission('/enquiry');
  const quotePerm = getPermission('/quotation');

  const viewAll = perm.view_all === true;
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [segData, setSegData] = useState([]);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [editingRecord, setEditingRecord] = useState(null);
  const [expandedRowKeys, setExpandedRowKeys] = useState([]);
  const [apiMessage, msgContext] = useMessage();
  const [generatedEQNo, setGeneratedEQNo] = useState("");
  const [value, setValue] = useState("All Enquiry");
const [dateRange, setDateRange] = useState(null);
  const [dateFilterType, setDateFilterType] = useState("Next Follow Up");
  const [moreActionsLabel, setMoreActionsLabel] = useState("More Actions");
  const [createdByFilter, setCreatedByFilter] = useState(null);
  const [completeStatuses, setCompleteStatuses] = useState([]);
  const [hotStatuses, setHotStatuses] = useState([]);
  const [wonStatuses, setWonStatuses] = useState([]);
  const [allStatusConfig, setAllStatusConfig] = useState([]);

  const [searchText, setSearchText] = useState("");

  const [statusFilter, setStatusFilter] = useState(null);
  const [sourceFilter, setSourceFilter] = useState(null);
  const [draftFilter, setDraftFilter] = useState(null); // null=all, true=draft, false=non-draft

  const [activeFilter, setActiveFilter] = useState({ type: 'quote', value: 'all' });

  const [userMap, setUserMap] = useState({});
  const [quotations, setQuotations] = useState([]);
  const [salesExecNames, setSalesExecNames] = useState([]);
  const [invoices, setInvoices] = useState([]);
  dayjs.extend(isSameOrBefore);
  dayjs.extend(isSameOrAfter);
  dayjs.extend(isBetween);

  const { Title, Text } = Typography;

  const handleSegChange = (val) => {
    setValue(val);
    if (val === "All Enquiry") {
      setData(segData);
    } else if (val === "Completed Enquiry") {
      const completed = segData.filter(
        (item) => completeStatuses.includes(item.eq_status?.trim())
      );
      setData(completed);
    }
  };

  const getAllServices = async () => {
    try {
      const user = await UserService.getOmeUser();
      const request = await EnquiryService.getAllEnquiries();

      // logged-in user's display name (to match assigned_to)
      const omeUser = JSON.parse(localStorage.getItem("ome_user") || "{}");
      const userName = omeUser?.name || omeUser?.user_name || "";

      let rows = request.data;

      // If not "view all", keep only enquiries assigned to the logged-in user
      if (!viewAll) {
        console.log("ENQUIRY FILTER DEBUG");
        console.log("userName:", JSON.stringify(userName));
        console.log("user.uid:", JSON.stringify(user.uid));
        console.log("all rows:", request.data.map(d => ({
          eq_id: d.eq_id,
          assigned_to: d.assigned_to,
          added_by: d.added_by,
          addedby: d.addedby,
        })));
        rows = rows.filter(d => {
          const assigned = (d.assigned_to || "").split(',').map(s => s.trim()).filter(Boolean);
          const isAssigned = assigned.includes(userName);
          const isCreator = String(d.addedby ?? "").trim() === String(user.uid).trim();
          return isAssigned || isCreator;
        });
      }

      const sortedData = rows
        .sort((a, b) => new Date(b.eq_date) - new Date(a.eq_date)) // latest first
        .map((item, index) => ({
          ...item,
          si_no: index + 1,
          key: item.eq_id,
          n_follow_up: item.enquiry_follow_up || item.n_follow_up || null,
          followup_current_date: item.followup_current_date || item.current_date || null,
        }));

      setSegData(sortedData);
      setData(sortedData);


    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getAllServices();
    loadCompleteStatuses();
    loadUserMap();
    loadQuotations();
    loadInvoices();
    loadSalesExecutives();
  }, []);

  const loadQuotations = async () => {
    try {
      const { QuotationService } = await import('../../Services/Manage/QuotationService');
      const res = await QuotationService.getAllQuotation();
      setQuotations(res.data || []);
    } catch (e) {
      console.error("Failed to load quotations", e);
    }
  };

  const loadInvoices = async () => {
    try {
      const { InvoiceService } = await import('../../Services/Manage/InvoiceService');
      const res = await InvoiceService.getAllInvoice();
      setInvoices(res.data || []);
    } catch (e) {
      console.error("Failed to load invoices", e);
    }
  };

  const loadSalesExecutives = async () => {
    try {
      const res = await AddEmployeesService.getByDepartment("Sales");

      const names = (res.data || []).map(e => e.name).filter(Boolean);

      setSalesExecNames(names);
    } catch (e) {
      console.error("Failed to load sales executives", e);
    }
  };

  const loadUserMap = async () => {
    try {
      const res = await UserService.getAllUsers();
      const list = res?.data || res || [];

      const map = {};
      list.forEach(u => {
        const uid = u.uid || u.user_id || u.id;
        const nm = u.name || u.user_name || u.username;
        if (uid) map[String(uid).trim()] = nm;
      });
      setUserMap(map);
    } catch (e) {
      console.error("Failed to load users", e);
    }
  };

  const loadCompleteStatuses = async () => {
    try {
      const { ConfigurationService } = await import('../../Services/Manage/ConfigurationService');
      const res = await ConfigurationService.getByType("enquiry_status");
      const allStatuses = res.data || [];
      setAllStatusConfig(allStatuses);
      setCompleteStatuses(allStatuses.filter(item => item.move_to_complete).map(item => item.label.trim()));
      setHotStatuses(allStatuses.filter(item => item.lead_temperature === "hot").map(item => item.label.trim()));
      setWonStatuses(allStatuses.filter(item => item.label.trim().toLowerCase() === "won").map(item => item.label.trim()));
    } catch (e) {
      console.error("Failed to load complete statuses", e);
    }
  };

  const handleExpandToggle = (record) => {
    setExpandedRowKeys((prev) =>
      prev.includes(record.eq_id)
        ? prev.filter((k) => k !== record.eq_id)
        : [...prev, record.eq_id]
    );
  };

  const handleAdd = () => {
    setEditingRecord(null);
    setDrawerOpen(true);
  };

  const handleEdit = (record) => {
    navigate(`/enquiry/edit/${record.eq_id}`);
  };

  const handleView = (record) => {
    navigate(`/enquiry/view/${record.eq_id}`);
  };

  const handleSubmit = async (values) => {
    const user = await UserService.getOmeUser();
    const _ome = JSON.parse(localStorage.getItem("ome_user") || "{}");
    const _actionBy = _ome?.name || _ome?.user_name || "";
    const payload = { ...values, added_by: user.uid, action_by: _actionBy };

    if (editingRecord) {
      const edit_load = {
        ...payload,
        edit_e_id: editingRecord.e_id,
        edit_c_id: editingRecord.c_id,
      };



      const request = await EnquiryService.updateEnquiries(edit_load);

      if (request.status) {
        apiMessage.success(request.message);
        getAllServices();
      } else {
        apiMessage.error(request.message);
      }
    } else {
      const request = await EnquiryService.createEnquiries(payload);

      if (request.status) {
        apiMessage.success(request.message);
        getAllServices();
      } else {
        apiMessage.error(request.message);
      }
    }
    setDrawerOpen(false);
  };

  const handleDelete = async (values) => {
    try {
      const edit_load = {
        e_id: values.e_id,
        c_id: values.c_id,
      };

      const req = await EnquiryService.deleteEnquiries(edit_load);
      if (req.status) {
        apiMessage.success(req.message);
        getAllServices();
      } else {
        apiMessage.error(req.message);
        getAllServices();
      }
    } catch (error) {
      console.error(error);
      apiMessage.error("Failed to delete enquiry");
    }
  };




  const parseItems = (items) => {
    if (Array.isArray(items)) return items;

    try {
      return JSON.parse(items || "[]");
    } catch {
      return [];
    }
  };




  const getServiceNamesFromRecord = (item) => {
    const services = parseItems(item.service_items);

    if (services.length > 0) {
      return services
        .map((s) => s.service_name)
        .filter(Boolean);
    }

    return item.service_name ? [item.service_name] : [];
  };

  const serviceOptions = [
    ...new Set(
      segData.flatMap((item) => getServiceNamesFromRecord(item))
    ),
  ].map((service) => ({
    label: service,
    value: service,
  }));

  const REPORT_COLUMNS = [
    { label: "Enquiry ID" },
    { label: "Customer" },
    { label: "Service" },
    { label: "Source" },
    { label: "Status" },
    { label: "Expected Value" },
    { label: "Next Follow-up" },
    { label: "Assigned To" },
  ];

  const buildReportRows = () => data.map((d) => {
    const services = parseItems(d.service_items);
    const service = services.length ? services[services.length - 1].service_name : (d.service_name || "-");
    let amt = parseFloat(String(d.total_amount ?? 0).replace(/[^0-9.-]/g, "")) || 0;
    if (!amt) {
      const products = parseItems(d.product_items);
      amt = [...services, ...products].reduce((a, it) => a + (Number(it.unit_price) || 0), 0);
    }
    let fuDate = "-";
    if (d.n_follow_up) {
      let fd = dayjs(d.n_follow_up, "DD-MM-YYYY", true);
      if (!fd.isValid()) fd = dayjs(d.n_follow_up);
      fuDate = fd.isValid() ? fd.format("DD-MM-YYYY") : "-";
    }
    return {
      "Enquiry ID": d.eq_id || "-",
      "Customer": d.name || "-",
      "Service": service || "-",
      "Source": d.eq_source || "-",
      "Status": d.eq_status || "-",
      "Expected Value": `${d.currency || ""} ${amt.toLocaleString('en-IN')}`,
      "Next Follow-up": fuDate,
      "Assigned To": d.assigned_to || "-",
    };
  });

  const reportDateStamp = () => dayjs().format("YYYY-MM-DD");

  const handleExportExcel = () => {
    const rows = buildReportRows();
    const ws = XLSX.utils.json_to_sheet(rows);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Enquiries Report");
    XLSX.writeFile(wb, `Enquiries-Report-${reportDateStamp()}.xlsx`);
  };

  const handleExportPDF = () => {
    const rows = buildReportRows();
    const doc = new jsPDF({ orientation: "landscape" });
    doc.setFontSize(14);
    doc.text("Enquiries Report", 14, 14);
    doc.setFontSize(9);
    doc.text(`Generated: ${new Date().toLocaleString('en-GB')}`, 14, 20);
    autoTable(doc, {
      startY: 26,
      head: [REPORT_COLUMNS.map((c) => c.label)],
      body: rows.map((r) => REPORT_COLUMNS.map((c) => r[c.label])),
      styles: { fontSize: 8 },
      headStyles: { fillColor: [22, 88, 180] },
    });
    doc.save(`Enquiries-Report-${reportDateStamp()}.pdf`);
  };

  const exportMenuItems = [
    { key: "excel", label: "Download as Excel (.xlsx)", onClick: handleExportExcel },
    { key: "pdf", label: "Download as PDF", onClick: handleExportPDF },
  ];




  const columns = [
    { title: 'S. No', dataIndex: 'si_no', key: 'si_no', align: 'center', width: 70 },
    { title: 'Enquiry ID', dataIndex: 'eq_id', key: 'eq_id', render: (v) => <span style={{ color: '#1677ff', fontWeight: 600 }}>{v}</span> },
    { title: 'Customer Name', dataIndex: 'name', key: 'name', render: (name) => name || '-' },
    {
      title: 'Service / Requirement',
      key: 'latest_service',
      render: (_, record) => {
        const services = parseItems(record.service_items);
        return services.length ? services[services.length - 1].service_name : (record.service_name || "-");
      },
    },
    { title: 'Lead Source', dataIndex: 'eq_source', key: 'eq_source', render: (v) => v || '-' },
    {
      title: 'Lead Status',
      key: 'lead_status',
      render: (_, record) => {
        const temp = getLeadTemp(record);
        const t = temp ? tempColors[temp] : null;
        if (!t) return <span style={{ color: '#999' }}>-</span>;
        return (
          <span style={{ background: t.bg, color: t.color, fontWeight: 600, fontSize: 12, padding: '2px 10px', borderRadius: 12 }}>
            {t.label}
          </span>
        );
      },
    },
    {
      title: 'Lead Score',
      key: 'lead_score',
      align: 'center',
      render: (_, record) => {
        const score = getLeadScore(record);
        const color = score >= 80 ? '#52c41a' : score >= 50 ? '#fa8c16' : '#1677ff';
        return (
          <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4, fontWeight: 700, color }}>
            {score} <span style={{ color: '#fadb14' }}>★</span>
          </span>
        );
      },
    },
    {
      title: 'Expected Value',
      key: 'total_amount',
      render: (_, record) => {
        let amt = parseFloat(String(record.total_amount ?? 0).replace(/[^0-9.-]/g, "")) || 0;
        if (!amt) {
          const services = parseItems(record.service_items);
          const products = parseItems(record.product_items);
          amt = [...services, ...products].reduce((a, it) => a + (Number(it.unit_price) || 0), 0);
        }
        return `${record.currency || ''} ${amt.toLocaleString('en-IN')}`;
      },
    },
    {
      title: 'Next Follow-up',
      dataIndex: 'n_follow_up',
      key: 'n_follow_up',
      render: (value) => {
        if (!value) return '-';
        let d = dayjs(value, "DD-MM-YYYY", true);
        if (!d.isValid()) d = dayjs(value);
        if (!d.isValid()) return value;
        const isToday = d.isSame(dayjs(), 'day');
        const isOverdue = d.isBefore(dayjs(), 'day');
        const color = isToday ? '#52c41a' : isOverdue ? '#f5222d' : '#333';
        return <span style={{ color, fontWeight: isToday || isOverdue ? 600 : 400 }}>{d.format('DD-MM-YYYY')}</span>;
      },
    },
    ...(viewAll ? [{
      title: 'Assigned To',
      dataIndex: 'assigned_to',
      key: 'assigned_to',
      render: (v) => v || '-',
    }, {
      title: 'Created By',
      key: 'created_by',
      render: (_, record) => {
        const creatorUid = String(record.addedby ?? record.created_by ?? "").trim();
        return userMap[creatorUid] || creatorUid || '-';
      },
    }] : [{
      title: 'Assigned By',
      dataIndex: 'assigned_by',
      key: 'assigned_by',
      render: (v) => v || '-',
    }]),
    {
      title: 'Actions',
      key: 'actions',
      fixed: 'right',
      render: (_, record) => (
        <Space>
          <Button
            size="middle"
            icon={expandedRowKeys.includes(record.eq_id) ? <EyeInvisibleOutlined /> : <EyeOutlined />}
            onClick={() => handleExpandToggle(record)}
          />
          <Tooltip title={!perm.edit ? "You don't have permission to edit" : ""}>
            <Button size="middle" icon={<EditOutlined />} onClick={() => handleEdit(record)} disabled={!perm.edit} />
          </Tooltip>
          <Tooltip title={!perm.delete ? "You don't have permission to delete" : ""}>
            <Popconfirm title="Are you sure to delete?" onConfirm={() => handleDelete(record)} disabled={!perm.delete}>
              <Button size="middle" danger icon={<DeleteOutlined />} disabled={!perm.delete} />
            </Popconfirm>
          </Tooltip>
        </Space>
      ),
    },
  ];
  const applyAllFilters = (search = "", service = "", range = dateRange, type = dateFilterType, status = statusFilter, source = sourceFilter) => {
    let filtered = [...segData];

    // Search filter
    if (search) {
      const lower = search.toLowerCase();
      filtered = filtered.filter(
        (item) =>
          item.eq_id?.toLowerCase().includes(lower) ||
          item.service_name?.toLowerCase().includes(lower) ||
          item.eq_source?.toLowerCase().includes(lower) ||
          item.eq_status?.toLowerCase().includes(lower) ||
          item.name?.toLowerCase().includes(lower) ||
          item.mobile_no?.toString().includes(lower)
      );
    }

    // Service filter
    if (service) {
      filtered = filtered.filter((item) =>
        getServiceNamesFromRecord(item).includes(service)
      );
    }

    // Date filter
    if (range && range.length === 2) {
      const [start, end] = range;
      filtered = filtered.filter((item) => {
        let fieldDate = null;
        if (type === "Next Follow Up" || type === "n_follow_up") {
          const val = item.n_follow_up || item.enquiry_follow_up;
          fieldDate = val ? dayjs(val) : null;
        } else {
          fieldDate = item[type] ? dayjs(item[type]) : null;
        }

        return (
          fieldDate &&
          fieldDate.isBetween(start.startOf("day"), end.endOf("day"), null, "[]")
        );

      });
    }

    if (status) filtered = filtered.filter(item => item.eq_status?.trim() === status);
    if (source) filtered = filtered.filter(item => item.eq_source?.trim() === source);

    setData(filtered);
  };

  const applyDraftFilter = (draft) => {
    setDraftFilter(draft);
    let filtered = [...segData];
    if (draft === true) filtered = filtered.filter(item => item.is_draft === true);
    else if (draft === false) filtered = filtered.filter(item => !item.is_draft);
    if (statusFilter) filtered = filtered.filter(item => item.eq_status?.trim() === statusFilter);
    if (sourceFilter) filtered = filtered.filter(item => item.eq_source?.trim() === sourceFilter);
    if (searchText) {
      const lower = searchText.toLowerCase();
      filtered = filtered.filter(item =>
        item.eq_id?.toLowerCase().includes(lower) ||
        item.name?.toLowerCase().includes(lower) ||
        item.eq_source?.toLowerCase().includes(lower) ||
        item.eq_status?.toLowerCase().includes(lower) ||
        item.mobile_no?.toString().includes(lower)
      );
    }
    setData(filtered);
  };
  const expandedRowRender = (record) => {
    const followUpRows =
      Array.isArray(record.follow_ups) && record.follow_ups.length > 0
        ? record.follow_ups.map((item, index) => ({
          key: `${record.eq_id}-followup-${index}`,
          follow_date: item.follow_date || item.n_follow_up || null,
          current_date: item.current_date || item.followup_current_date || null,
          summary: item.summary || "-",
        }))
        : [
          {
            key: record.eq_id,
            follow_date: record.n_follow_up || null,
            current_date: record.followup_current_date || record.current_date || null,
            summary: record.summary || record.notes || "-",
          },
        ];

    let serviceRows = parseItems(record.service_items);
    let productRows = parseItems(record.product_items);

    if (!serviceRows.length && record.service_name) {
      serviceRows = [
        {
          service_name: record.service_name,
          unit_price: record.service_unit_price || record.unit_price || 0,
          unit: record.service_unit || record.unit || "",

        },
      ];
    }

    if (!productRows.length && record.product_name) {
      productRows = [
        {
          product_name: record.product_name,
          unit_price: record.product_unit_price || record.unit_price || 0,
          unit: record.product_unit || record.unit || "",
          hsn_code: record.product_hsn_code || record.sku || record.code_name || "",
        },
      ];
    }

    const serviceUnitTotal = serviceRows.reduce(
      (sum, item) => sum + Number(item.unit_price || 0),
      0
    );

    const productUnitTotal = productRows.reduce(
      (sum, item) => sum + Number(item.unit_price || 0),
      0
    );

    const infoItems = [
      ["Customer Name", record.name],
      ["Mobile No", record.mobile_no],
      ["Address", record.address],
      ["Source", record.eq_source],
      ["Service", parseItems(record.service_items).map(s => s.service_name).join(", ") || record.service_name || "-"],
      ["Status", record.eq_status],
      ["Amount", (() => {
        let amt = parseFloat(String(record.total_amount ?? 0).replace(/[^0-9.-]/g, "")) || 0;
        if (!amt) {
          const s = parseItems(record.service_items);
          const p = parseItems(record.product_items);
          amt = [...s, ...p].reduce((a, it) => a + (Number(it.unit_price) || 0), 0);
        }
        return `${record.currency || ""} ${amt.toLocaleString('en-IN')}`;
      })()],
      ["Added By", record.addedby],
      ["Added On", record.eq_date ? dayjs(record.eq_date).format("DD-MM-YYYY hh:mm A") : "-"],
      ["Updated On", record.enquiry_updated_on ? dayjs(record.enquiry_updated_on).format("DD-MM-YYYY hh:mm A") : "-"],
      // ["Description", record.eq_description],
      // ["Note", record.notes],
    ];




    return (
      <div
        style={{
          background: "#fafafa",
          border: "1px solid #e8e8e8",
          borderRadius: 10,
          padding: 16,
        }}
      >
        <Typography.Title level={5} style={{ marginTop: 0, marginBottom: 12 }}>
          Enquiry Details
        </Typography.Title>

        <Row gutter={[12, 12]}>
          {infoItems.map(([label, value], index) => (
            <Col xs={24} sm={12} md={8} lg={6} key={index}>
              <div
                style={{
                  background: "#fff",
                  border: "1px solid #eeeeee",
                  borderRadius: 8,
                  padding: "10px 12px",
                  minHeight: 68,
                }}
              >
                <div style={{ fontSize: 12, color: "#777", marginBottom: 4 }}>
                  {label}
                </div>
                <div style={{ fontSize: 14, fontWeight: 600, color: "#222" }}>
                  {value || "-"}
                </div>
              </div>
            </Col>
          ))}
        </Row>



        <Divider style={{ margin: "16px 0 12px" }} />

        <Row gutter={16}>
          <Col xs={24} md={12}>
            <Typography.Text strong>Service Details</Typography.Text>

            <Table
              size="small"
              bordered
              pagination={false}
              style={{ marginTop: 10 }}
              columns={[
                {
                  title: "S.No",
                  width: 70,
                  align: "center",
                  render: (_, __, index) => index + 1,
                },
                {
                  title: "Service Name",
                  dataIndex: "service_name",
                },
                {
                  title: "Unit Price",
                  dataIndex: "unit_price",
                  align: "right",
                },
              ]}
              dataSource={serviceRows.map((item, index) => ({
                ...item,
                key: `service-${record.eq_id}-${index}`,
              }))}
              summary={() => (
                <Table.Summary.Row>
                  <Table.Summary.Cell index={0} colSpan={2}>
                    <b>Total</b>
                  </Table.Summary.Cell>
                  <Table.Summary.Cell index={2} align="right">
                    <b>{serviceUnitTotal}</b>
                  </Table.Summary.Cell>
                </Table.Summary.Row>
              )}
              locale={{ emptyText: "No Service Details Found" }}
            />
          </Col>

          <Col xs={24} md={12}>
            <Typography.Text strong>Product Details</Typography.Text>

            <Table
              size="small"
              bordered
              pagination={false}
              style={{ marginTop: 10 }}
              columns={[
                {
                  title: "S.No",
                  width: 70,
                  align: "center",
                  render: (_, __, index) => index + 1,
                },
                {
                  title: "Product Name",
                  dataIndex: "product_name",
                },
                {
                  title: "Unit Price",
                  dataIndex: "unit_price",
                  align: "right",
                },
              ]}
              dataSource={productRows.map((item, index) => ({
                ...item,
                key: `product-${record.eq_id}-${index}`,
              }))}
              summary={() => (
                <Table.Summary.Row>
                  <Table.Summary.Cell index={0} colSpan={2}>
                    <b>Total</b>
                  </Table.Summary.Cell>
                  <Table.Summary.Cell index={2} align="right">
                    <b>{productUnitTotal}</b>
                  </Table.Summary.Cell>
                </Table.Summary.Row>
              )}
              locale={{ emptyText: "No Product Details Found" }}
            />
          </Col>
        </Row>





        <Divider style={{ margin: "16px 0 12px" }} />

        <Typography.Text strong>Follow-up Details</Typography.Text>

        <Row gutter={[12, 12]} style={{ marginTop: 10 }}>
          {followUpRows.map((item) => (
            <Col xs={24} md={8} key={item.key}>
              <div
                style={{
                  background: "#fff",
                  border: "1px solid #eeeeee",
                  borderRadius: 8,
                  padding: 12,
                }}
              >
                <div style={{ fontSize: 13 }}>
                  <b>Follow-up:</b>{" "}
                  {item.follow_date ? dayjs(item.follow_date).format("DD-MM-YYYY") : "-"}
                </div>
                <div style={{ fontSize: 13, marginTop: 6 }}>
                  <b>Added On:</b>{" "}
                  {item.current_date ? dayjs(item.current_date).format("DD-MM-YYYY") : "-"}
                </div>
                <div style={{ fontSize: 13, marginTop: 6 }}>
                  <b>Summary:</b> {item.summary || "-"}
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </div>
    );
  };

  const getSegmentData = () => {
    if (value === "Completed Enquiry") {
      return segData.filter((item) => completeStatuses.includes(item.eq_status?.trim()));
    }
    return segData;
  };

  const getQuickStats = () => {
    const baseData = getSegmentData();
    const today = dayjs().startOf("day");
    const last7 = dayjs().subtract(6, "day").startOf("day");
    const last30 = dayjs().subtract(29, "day").startOf("day");
    return {
      today: baseData.filter(d => d.eq_date && dayjs(d.eq_date).isAfter(today)).length,
      last7: baseData.filter(d => d.eq_date && dayjs(d.eq_date).isAfter(last7)).length,
      last30: baseData.filter(d => d.eq_date && dayjs(d.eq_date).isAfter(last30)).length,
      total: baseData.length,
    };
  };

  const getFollowUpStats = () => {
    const source = getSegmentData();
    const todayStart = dayjs().startOf("day");
    const todayEnd = dayjs().endOf("day");
    const next7End = dayjs().add(7, "day").endOf("day");
    const next30End = dayjs().add(30, "day").endOf("day");
    const withFollowUp = source.filter(d => d.n_follow_up);
    return {
      today: withFollowUp.filter(d =>
        dayjs(d.n_follow_up).isBetween(todayStart, todayEnd, null, "[]")
      ).length,
      next7: withFollowUp.filter(d =>
        dayjs(d.n_follow_up).isAfter(todayEnd) &&
        dayjs(d.n_follow_up).isSameOrBefore(next7End)
      ).length,
      next30: withFollowUp.filter(d =>
        dayjs(d.n_follow_up).isAfter(todayEnd) &&
        dayjs(d.n_follow_up).isSameOrBefore(next30End)
      ).length,
      total: withFollowUp.length,
    };
  };

const applyQuickDateFilter = (days, label) => {
    const end = dayjs();
    const start = days === 0
      ? end.startOf("day")
      : end.subtract(days - 1, "day").startOf("day");
    const range = [start, end];
    setDateFilterType("eq_date");
    setDateRange(range);
    setMoreActionsLabel(label || "More Actions");
    applyAllFilters(searchText, "", range, "eq_date", statusFilter, sourceFilter);
  };

  const applyMonthOrYearFilter = (unit, label) => {
    // unit: "month" | "year". Filters by eq_date (Added On), same field
    // used elsewhere for period-based reporting on this dashboard.
    const start = dayjs().startOf(unit);
    const end = dayjs().endOf(unit);
    const range = [start, end];
    setDateFilterType("eq_date");
    setDateRange(range);
    setMoreActionsLabel(label);
    applyAllFilters(searchText, "", range, "eq_date", statusFilter, sourceFilter);
  };

  const applyAllTimeFilter = () => {
    setDateRange(null);
    setDateFilterType("eq_date");
    setMoreActionsLabel("More Actions");
    applyAllFilters(searchText, "", null, "eq_date", statusFilter, sourceFilter);
  };

  const applyFollowUpDateFilter = (days) => {
    const start = dayjs().startOf("day");
    const end = days === 0
      ? dayjs().endOf("day")
      : dayjs().add(days, "day").endOf("day");
    const range = [start, end];
    setDateFilterType("n_follow_up");
    setDateRange(range);
    applyAllFilters("", "", range, "n_follow_up");
  };

  const clearDateFilters = () => {
    setDateRange(null);
    setDateFilterType("Next Follow Up");
    setSearchText("");
    setActiveFilter({ type: 'quote', value: 'all' });
    setStatusFilter(null);
    setSourceFilter(null);
    setDraftFilter(null);
    setData(segData);
  };

  const quickStats = getQuickStats();
  const followUpStats = getFollowUpStats();

  // ---- Period boundaries ----
  const today = dayjs().startOf("day");
  const yesterdayStart = dayjs().subtract(1, "day").startOf("day");
  const yesterdayEnd = dayjs().subtract(1, "day").endOf("day");

  const thisWeekStart = dayjs().subtract(6, "day").startOf("day");
  const lastWeekStart = dayjs().subtract(13, "day").startOf("day");
  const lastWeekEnd = dayjs().subtract(7, "day").endOf("day");

  const thisMonthStart = dayjs().subtract(29, "day").startOf("day");
  const lastMonthStart = dayjs().subtract(59, "day").startOf("day");
  const lastMonthEnd = dayjs().subtract(30, "day").endOf("day");

  // ---- Helpers ----
  const countBetween = (start, end) =>
    segData.filter(d => {
      if (!d.eq_date) return false;
      const dt = dayjs(d.eq_date);
      return dt.isSameOrAfter(start) && dt.isSameOrBefore(end);
    }).length;

  const countAfter = (start) =>
    segData.filter(d => d.eq_date && dayjs(d.eq_date).isSameOrAfter(start)).length;

  const trend = (current, previous, label) => {
    if (previous === 0) return current > 0 ? `↑ new vs ${label}` : "";
    const pct = Number((((current - previous) / previous) * 100).toFixed(0));
    if (pct > 0) return `↑ ${pct}% vs ${label}`;
    if (pct < 0) return `↓ ${Math.abs(pct)}% vs ${label}`;
    return "";
  };

  // ---- Current vs previous counts ----
  const todayCount = countAfter(today);
  const yesterdayCount = countBetween(yesterdayStart, yesterdayEnd);
  const thisWeekCount = countAfter(thisWeekStart);
  const lastWeekCount = countBetween(lastWeekStart, lastWeekEnd);
  const thisMonthCount = countAfter(thisMonthStart);
  const lastMonthCount = countBetween(lastMonthStart, lastMonthEnd);

  // TEMP DEBUG
  const hotLeads = segData.filter(d => hotStatuses.includes(d.eq_status?.trim()));
  // ---- Last 30 days source ----
  const panelData = segData; // all-time; swap to a 30-day filter if needed

  // ---- Enquiry Pipeline (status counts in config order) ----
  const pipelineColors = ["#1677ff", "#13c2c2", "#fa8c16", "#722ed1", "#eb2f96", "#52c41a", "#f5222d"];
  const pipeline = allStatusConfig.map((s, i) => ({
    label: s.label,
    count: panelData.filter(d => d.eq_status?.trim() === s.label.trim()).length,
    color: pipelineColors[i % pipelineColors.length],
  }));
  const pipelineMax = Math.max(...pipeline.map(p => p.count), 1);
  const wonCount = panelData.filter(d => wonStatuses.includes(d.eq_status?.trim())).length;
  const conversionRate = panelData.length ? ((wonCount / panelData.length) * 100).toFixed(2) : "0.00";

  // ---- Revenue Forecast (by lead temperature) ----
  const tempOf = (status) => {
    const cfg = allStatusConfig.find(s => s.label.trim() === status?.trim());
    return cfg?.lead_temperature || null;
  };

  const tempColors = {
    hot: { color: '#f5222d', bg: '#fff1f0', label: 'Hot' },
    warm: { color: '#fa8c16', bg: '#fff7e6', label: 'Warm' },
    cold: { color: '#1677ff', bg: '#e6f4ff', label: 'Cold' },
  };
  const getLeadTemp = (record) => {
    const cfg = allStatusConfig.find(s => s.label.trim() === record.eq_status?.trim());
    return cfg?.lead_temperature || null;
  };
  const getLeadScore = (record) => {
    const temp = getLeadTemp(record);
    const base = temp === 'hot' ? 80 : temp === 'warm' ? 50 : 20;
    const span = temp === 'hot' ? 20 : 30;
    const idNum = (record.eq_id || "").replace(/\D/g, "");
    const seed = idNum ? parseInt(idNum.slice(-2), 10) || 0 : 0;
    return base + (seed % span);
  };

  const revByTemp = { hot: 0, warm: 0, cold: 0 };
  panelData.forEach(d => {
    const t = tempOf(d.eq_status);
    if (!t) return;
    let amt = parseFloat(String(d.total_amount ?? 0).replace(/[^0-9.-]/g, "")) || 0;
    if (!amt) {
      const services = parseItems(d.service_items);
      const products = parseItems(d.product_items);
      amt = [...services, ...products].reduce((a, it) => a + (Number(it.unit_price) || 0), 0);
    }
    revByTemp[t] += amt;
  });

  const revenueTotal = revByTemp.hot + revByTemp.warm + revByTemp.cold;
  const revenueData = [
    { name: "Hot Leads", value: revByTemp.hot, color: "#f5222d" },
    { name: "Warm Leads", value: revByTemp.warm, color: "#fa8c16" },
    { name: "Cold Leads", value: revByTemp.cold, color: "#1677ff" },
  ];

  // ---- Lead Source Analytics ----
  const sourceColors = ["#1677ff", "#13c2c2", "#fa8c16", "#722ed1", "#eb2f96", "#bfbfbf"];
  const sourceCounts = {};
  panelData.forEach(d => {
    const src = d.eq_source?.trim() || "Others";
    sourceCounts[src] = (sourceCounts[src] || 0) + 1;
  });
  const sourceTotal = Object.values(sourceCounts).reduce((a, b) => a + b, 0);
  const sourceData = Object.entries(sourceCounts).map(([name, count], i) => ({
    name,
    value: count,
    pct: sourceTotal ? Math.round((count / sourceTotal) * 100) : 0,
    color: sourceColors[i % sourceColors.length],
  }));

  // ---- Follow-up Summary ----
  const fuTodayStart = dayjs().startOf("day");
  const fuTodayEnd = dayjs().endOf("day");


  const parseFU = (val) => {
    if (!val) return null;
    let d = dayjs(val, "DD-MM-YYYY", true);
    if (!d.isValid()) d = dayjs(val);
    return d.isValid() ? d : null;
  };

  const withFU = panelData.map(d => ({ ...d, _fu: parseFU(d.n_follow_up) })).filter(d => d._fu);
  const followUpSummary = {
    today: withFU.filter(d => d._fu.isBetween(fuTodayStart, fuTodayEnd, null, "[]")).length,
    overdue: withFU.filter(d => d._fu.isBefore(fuTodayStart)).length,
    next7: withFU.filter(d => d._fu.isAfter(fuTodayEnd) && d._fu.isSameOrBefore(dayjs().add(7, "day").endOf("day"))).length,
    next30: withFU.filter(d => d._fu.isAfter(fuTodayEnd) && d._fu.isSameOrBefore(dayjs().add(30, "day").endOf("day"))).length,
  };

  const _omeUserFU = JSON.parse(localStorage.getItem("ome_user") || "{}");
  const _userNameFU = _omeUserFU?.name || _omeUserFU?.user_name || "";

  const followUpDueList = [...withFU]
    .filter(d => d._fu.isSameOrBefore(fuTodayEnd, "day"))
    .filter(d => viewAll || (d.assigned_to || "").split(',').map(s => s.trim()).includes(_userNameFU))
    .sort((a, b) => a._fu.valueOf() - b._fu.valueOf())
    .map(d => {
      const services = parseItems(d.service_items);
      const serviceName = services.length
        ? services[services.length - 1].service_name
        : (d.service_name || "-");
      const assignedNames = (d.assigned_to || "").split(',').map(s => s.trim()).filter(Boolean);
      const creatorName = userMap[String(d.addedby ?? "").trim()];
      const assignedDisplay = viewAll
        ? (d.assigned_to || creatorName || "-")
        : (assignedNames.includes(_userNameFU) ? _userNameFU : (d.assigned_to || creatorName || "-"));
      return {
        eq_id: d.eq_id,
        company: d.name || "-",
        service: serviceName,
        contact: d.name || "-",
        assigned: assignedDisplay,
        mobile: d.mobile_no || d.contact_whatsapp || "",
        time: d._fu.format("DD-MM-YYYY"),
        isOverdue: d._fu.isBefore(fuTodayStart, "day"),
        daysOverdue: fuTodayStart.diff(d._fu, "day"),
      };
    });

  const handleViewAllFollowUps = () => {
    const ids = new Set(followUpDueList.map(f => f.eq_id));
    setData(segData.filter(d => ids.has(d.eq_id)));
    document.getElementById('enquiry-table-section')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };



  withFU.forEach(d => {
    console.log("FU row →", {
      eq_id: d.eq_id,
      n_follow_up_raw: d.n_follow_up,
      parsed: dayjs(d.n_follow_up).format("DD-MM-YYYY"),
      isToday: dayjs(d.n_follow_up).isBetween(fuTodayStart, fuTodayEnd, null, "[]"),
      isOverdue: dayjs(d.n_follow_up).isBefore(fuTodayStart),
    });
  });

  const row1 = [
    { title: "New Enquiries (Today)", value: todayCount, sub: trend(todayCount, yesterdayCount, "yesterday"), color: "#1677ff", bg: "#f0f7ff", icon: <FileTextOutlined /> },
    { title: "Enquiries (This Week)", value: thisWeekCount, sub: trend(thisWeekCount, lastWeekCount, "last week"), color: "#13c2c2", bg: "#f0fffe", icon: <CalendarOutlined /> },
    { title: "Enquiries (This Month)", value: thisMonthCount, sub: trend(thisMonthCount, lastMonthCount, "last month"), color: "#722ed1", bg: "#f9f0ff", icon: <LineChartOutlined /> },
    { title: "Total Enquiries", value: segData.length, sub: "All time total", color: "#fa8c16", bg: "#fff7e6", icon: <TeamOutlined /> },
  ];

  const row2 = [
    { title: "Hot Leads", value: segData.filter(d => hotStatuses.includes(d.eq_status?.trim())).length, sub: "High priority leads", color: "#f5222d", bg: "#fff1f0", icon: <FireOutlined /> },
    { title: "Quotations Sent", value: segData.filter(d => d.eq_status?.toLowerCase().includes("quotation")).length, sub: "Awaiting response", color: "#1677ff", bg: "#f0f7ff", icon: <FileDoneOutlined /> },
    { title: "Won Deals", value: segData.filter(d => wonStatuses.includes(d.eq_status?.trim()) && d.eq_date && dayjs(d.eq_date).isSameOrAfter(thisMonthStart)).length, sub: "This month", color: "#52c41a", bg: "#f6ffed", icon: <TrophyOutlined /> },
    {
      title: "Expected Revenue",
      value: `₹ ${segData
        .filter(d => hotStatuses.includes(d.eq_status?.trim()))
        .reduce((s, d) => {
          let amt = parseFloat(String(d.total_amount ?? 0).replace(/[^0-9.-]/g, "")) || 0;
          if (!amt) {
            const services = parseItems(d.service_items);
            const products = parseItems(d.product_items);
            amt = [...services, ...products].reduce(
              (a, it) => a + (Number(it.unit_price) || 0), 0
            );
          }
          return s + amt;
        }, 0)
        .toLocaleString('en-IN')}`,
      sub: "From hot leads",
      color: "#722ed1", bg: "#f9f0ff", icon: <DollarOutlined />
    },
  ];

  const StatCard = ({ title, value, sub, color, bg, icon }) => (
    <Card bodyStyle={{ padding: '10px 12px' }} style={{ borderRadius: 8, border: '1px solid #f0f0f0', height: '100%' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
        <div>
          <div style={{ fontSize: 11, color: '#888', marginBottom: 3 }}>{title}</div>
          <div style={{ fontSize: 22, fontWeight: 700, color: color, lineHeight: 1.2 }}>{value}</div>
          <div style={{ fontSize: 10, color: sub?.startsWith('↓') ? '#f5222d' : sub?.startsWith('↑') ? '#52c41a' : '#888', marginTop: 3 }}>{sub}</div>
        </div>
        <div style={{ width: 36, height: 36, borderRadius: '50%', background: bg, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 16, color: color, flexShrink: 0 }}>
          {icon}
        </div>
      </div>
    </Card>
  );
  return (
    <Card bordered={false} bodyStyle={{ padding: 0 }}>
      {/* Header */}
      <div style={{ padding: '8px 16px', borderBottom: '1px solid #f0f0f0', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div>
          <Typography.Title level={4} style={{ margin: 0, color: '#1658b4' }}>Enquiry Dashboard</Typography.Title>
          <Typography.Text type="secondary" style={{ fontSize: 12 }}>Dashboard &gt; Enquiry Dashboard</Typography.Text>
        </div>
        <Space>
          <Tooltip title={!perm.add ? "You don't have permission to create" : ""}>
            <Button
              size="middle" type="primary" icon={<PlusOutlined />}
              onClick={() => navigate('/enquiry/create')} disabled={!perm.add}
              style={{ background: '#1677ff', borderColor: '#1677ff' }}
            >
              New Enquiry
            </Button>
          </Tooltip>

          <Button
            size="middle" type="primary" icon={<PlusOutlined />}
            onClick={() => document.getElementById('enquiry-table-section')?.scrollIntoView({ behavior: 'smooth', block: 'start' })}
            style={{ background: '#52c41a', borderColor: '#52c41a' }}
          >
            Add Follow-up
          </Button>
          <Tooltip title={!quotePerm.add ? "You don't have permission to create quotation" : ""}>
            <Button
              size="middle" type="primary" icon={<PlusOutlined />}
              onClick={() => navigate('/quotation/create')} disabled={!quotePerm.add}
              style={{ background: '#722ed1', borderColor: '#722ed1' }}
            >
              Create Quotation
            </Button>
          </Tooltip>

<Dropdown
            trigger={['click']}
            overlay={
              <Menu
                onClick={({ key }) => {
                  if (key === 'today') applyQuickDateFilter(0, 'Today');
                  else if (key === 'last7') applyQuickDateFilter(7, 'Last 7 Days');
                  else if (key === 'last30') applyQuickDateFilter(30, 'Last 30 Days');
                  else if (key === 'thisMonth') applyMonthOrYearFilter('month', 'This Month');
                  else if (key === 'thisYear') applyMonthOrYearFilter('year', 'This Year');
                  else if (key === 'all') applyAllTimeFilter();
                }}
                items={[
                  { key: 'all', label: <span><CalendarOutlined style={{ marginRight: 6 }} />All Time</span> },
                  { key: 'today', label: <span><CalendarOutlined style={{ marginRight: 6 }} />Today</span> },
                  { key: 'last7', label: <span><CalendarOutlined style={{ marginRight: 6 }} />Last 7 Days</span> },
                  { key: 'last30', label: <span><CalendarOutlined style={{ marginRight: 6 }} />Last 30 Days</span> },
                  { key: 'thisMonth', label: <span><CalendarOutlined style={{ marginRight: 6 }} />This Month</span> },
                  { key: 'thisYear', label: <span><CalendarOutlined style={{ marginRight: 6 }} />This Year</span> },
                ]}
              />
            }
          >
            <Button size="middle" icon={<DownOutlined />}>
              {moreActionsLabel}
            </Button>
          </Dropdown>
        </Space>
      </div>

      {/* Stat Cards */}
      <div style={{ padding: '8px 16px 0' }}>
        <Row gutter={[8, 8]} style={{ marginBottom: 6 }}>
          {row1.map((card, i) => (
            <Col xs={24} sm={12} md={6} key={i}>
              <StatCard {...card} />
            </Col>
          ))}
        </Row>
        <Row gutter={[8, 8]}>
          {row2.map((card, i) => (
            <Col xs={24} sm={12} md={6} key={i}>
              <StatCard {...card} />
            </Col>
          ))}
        </Row>
      </div>

      {/* Pipeline / Revenue / Source / Follow-up panels */}
      <div style={{ padding: '6px 16px 0' }}>

        <Row gutter={[8, 8]}>
          {/* Enquiry Pipeline */}
          <Col xs={24} sm={12} lg={6}>
            <Card style={{ borderRadius: 10, height: '100%' }} bodyStyle={{ padding: 12 }}>
              <Typography.Text strong>Enquiry Pipeline</Typography.Text>
              <div style={{ marginTop: 6 }}>
                {pipeline.map((p, i) => (
                  <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 4 }}>
                    <div style={{ flex: 1, position: 'relative', height: 22 }}>
                      <div style={{
                        position: 'absolute', inset: 0,
                        width: `${Math.max((p.count / pipelineMax) * 100, 28)}%`,
                        background: `${p.color}1f`,
                        borderRadius: 5,
                      }} />
                      <div style={{ position: 'relative', display: 'flex', alignItems: 'center', height: '100%', padding: '0 10px' }}>
                        <span style={{ fontSize: 12, color: '#333' }}>{p.label}</span>
                      </div>
                    </div>
                    <span style={{ fontSize: 12, fontWeight: 700, color: '#222', minWidth: 22, textAlign: 'right' }}>{p.count}</span>
                  </div>
                ))}
              </div>
              <Divider style={{ margin: '6px 0 4px' }} />

              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end' }}>
                <div>
                  <div style={{ fontSize: 11, color: '#888' }}>Conversion Rate</div>
                  <div style={{ fontSize: 16, fontWeight: 700, color: '#52c41a' }}>{conversionRate}%</div>
                </div>
                <svg width="60" height="28" viewBox="0 0 70 34" fill="none">
                  <polyline points="2,30 18,22 30,25 46,12 66,4" stroke="#52c41a" strokeWidth="2.5" fill="none" strokeLinecap="round" strokeLinejoin="round" />
                  <polyline points="58,4 66,4 66,12" stroke="#52c41a" strokeWidth="2.5" fill="none" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </div>
            </Card>
          </Col>

          {/* Revenue Forecast */}
          <Col xs={24} sm={12} lg={6}>
            <Card style={{ borderRadius: 10, height: '100%' }} bodyStyle={{ padding: 12 }}>
              <Typography.Text strong>Revenue Forecast</Typography.Text>
              {revenueData.every(e => e.value === 0) ? (
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: 110, color: '#bbb', fontSize: 13, marginTop: 8 }}>
                  <span style={{ fontSize: 28 }}>💰</span>
                  <span style={{ marginTop: 6 }}>No revenue data yet</span>
                </div>
              ) : (
                <div style={{ display: 'flex', alignItems: 'center', gap: 40, marginTop: 8 }}>
                  <div style={{ width: 110, height: 110, flexShrink: 0 }}>
                    <ResponsiveContainer width="100%" height="100%">
                      <PieChart>
                        <RechartsTooltip
                          contentStyle={{ fontSize: 11, padding: '4px 8px', borderRadius: 6 }}
                          itemStyle={{ fontSize: 11, padding: 0 }}
                          formatter={(value, name) => [`₹ ${Number(value).toLocaleString('en-IN')} (${revenueTotal ? Math.round((value / revenueTotal) * 100) : 0}%)`, name]}
                        />
                        <Pie data={revenueData} dataKey="value" nameKey="name" innerRadius={30} outerRadius={50} paddingAngle={2}>
                          {revenueData.map((e, i) => <Cell key={i} fill={e.color} />)}
                        </Pie>
                      </PieChart>
                    </ResponsiveContainer>
                  </div>
                  <div style={{ flex: 1 }}>
                    {revenueData.map((e, i) => (
                      <div key={i} style={{ display: 'flex', alignItems: 'flex-start', gap: 6, fontSize: 12, marginBottom: 8 }}>
                        <span style={{ color: e.color, fontSize: 14, lineHeight: '16px', marginTop: 1, flexShrink: 0 }}>●</span>
                        <div>
                          <div style={{ fontWeight: 600, color: '#222' }}>{e.name} <span style={{ color: '#888', fontWeight: 400 }}>({revenueTotal ? Math.round((e.value / revenueTotal) * 100) : 0}%)</span></div>
                          <div style={{ color: '#555', fontSize: 11 }}>₹ {e.value.toLocaleString('en-IN')}</div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
              <Divider style={{ margin: '8px 0' }} />
              <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 12 }}>
                <b style={{ color: '#52c41a' }}>Total Expected Revenue</b>
                <b style={{ color: '#722ed1' }}>₹ {revenueTotal.toLocaleString('en-IN')}</b>
              </div>
            </Card>
          </Col>

          {/* Lead Source Analytics */}
          <Col xs={24} sm={12} lg={6}>
            <Card style={{ borderRadius: 10, height: '100%' }} bodyStyle={{ padding: 12 }}>
              <Typography.Text strong>Lead Source Analytics</Typography.Text>
              {sourceData.length === 0 ? (
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: 110, color: '#bbb', fontSize: 13, marginTop: 8 }}>
                  <span style={{ fontSize: 28 }}>📊</span>
                  <span style={{ marginTop: 6 }}>No source data yet</span>
                </div>
              ) : (
                <div style={{ display: 'flex', alignItems: 'center', gap: 16, marginTop: 8 }}>
                  <div style={{ width: 110, height: 110, flexShrink: 0 }}>
                    <ResponsiveContainer width="100%" height="100%">
                      <PieChart>
                        <RechartsTooltip
                          contentStyle={{ fontSize: 11, padding: '4px 8px', borderRadius: 6 }}
                          itemStyle={{ fontSize: 11, padding: 0 }}
                          formatter={(value, name, props) => [`${value} (${props.payload.pct}%)`, name]}
                        />
                        <Pie data={sourceData} dataKey="value" nameKey="name" innerRadius={30} outerRadius={50} paddingAngle={2}>
                          {sourceData.map((e, i) => <Cell key={i} fill={e.color} />)}
                        </Pie>
                      </PieChart>
                    </ResponsiveContainer>
                  </div>

                  <div style={{ flex: 1 }}>
                    {sourceData.map((e, i) => (
                      <div key={i} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: 12, marginBottom: 6 }}>
                        <span style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                          <span style={{ color: e.color, fontSize: 14 }}>●</span>
                          <span style={{ color: '#333' }}>{e.name}</span>
                        </span>
                        <span style={{ fontWeight: 700, color: '#333' }}>{e.pct}%</span>
                      </div>
                    ))}
                  </div>
                </div>

              )}
            </Card>
          </Col>

          {/* Follow-up Summary */}

          {/* Follow-up Summary */}
          <Col xs={24} sm={12} lg={6}>
            <Card style={{ borderRadius: 10, height: '100%' }} bodyStyle={{ padding: 12 }}>

              <Typography.Text strong>Follow-up Summary</Typography.Text>


              <div style={{ marginTop: 6 }}>
                {[
                  { label: "Today's Follow-ups", val: followUpSummary.today, color: '#1677ff', bg: '#f0f7ff', icon: <CalendarOutlined /> },
                  { label: "Overdue Follow-ups", val: followUpSummary.overdue, color: '#f5222d', bg: '#fff1f0', icon: <ExclamationCircleOutlined /> },
                  { label: "Next 7 Days", val: followUpSummary.next7, color: '#fa8c16', bg: '#fff7e6', icon: <ClockCircleOutlined /> },
                  { label: "Next 30 Days", val: followUpSummary.next30, color: '#52c41a', bg: '#f6ffed', icon: <CalendarOutlined /> },
                ].map((r, i) => (
                  <div key={i} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '5px 0', borderBottom: i < 3 ? '1px solid #f0f0f0' : 'none' }}>
                    <span style={{ display: 'flex', alignItems: 'center', gap: 10, fontSize: 13 }}>
                      <span style={{ width: 28, height: 28, borderRadius: 6, background: r.bg, color: r.color, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>{r.icon}</span>
                      {r.label}
                    </span>
                    <span style={{ fontSize: 18, fontWeight: 700, color: r.color }}>{r.val}</span>
                  </div>
                ))}
              </div>
            </Card>
          </Col>
        </Row>

        <Row gutter={[8, 8]} style={{ marginTop: 8 }} align="stretch">
          <Col xs={24} lg={8}>
            <Card style={{ borderRadius: 10, height: '100%' }} bodyStyle={{ padding: '8px 12px' }}>
              <div style={{ display: 'flex', alignItems: 'baseline', gap: 8 }}>
                <Typography.Text strong>Follow-ups Due</Typography.Text>
                <span style={{ fontSize: 12, color: '#999' }}>- Overdue and scheduled for today</span>
              </div>
              {followUpDueList.length > 0 && (
                <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 11, color: '#999', padding: '8px 4px 4px', borderBottom: '1px solid #f0f0f0' }}>
                  <span style={{ flex: 2 }}>Enquiry</span>
                  <span style={{ flex: 1.6 }}>Service</span>
                  <span style={{ flex: 1, textAlign: 'center' }}>Assigned</span>
                  <span style={{ flex: 1, textAlign: 'center' }}>Due Date</span>
                  <span style={{ width: 60 }}></span>
                </div>
              )}
              <div style={{ maxHeight: 220, overflowY: 'auto' }}>
                {followUpDueList.length === 0 ? (
                  <Typography.Text type="secondary" style={{ fontSize: 13, display: 'block', marginTop: 8 }}>No follow-ups found</Typography.Text>
                ) : (
                  followUpDueList.slice(0, 3).map((f) => (
                    <div key={f.eq_id} style={{ display: 'flex', alignItems: 'center', padding: '6px 4px', borderBottom: '1px solid #f5f5f5' }}>
                      <div style={{ flex: 2 }}>
                        <div style={{ fontSize: 12, fontWeight: 600, color: '#222' }}>{f.company}</div>
                        <div style={{ fontSize: 10, color: '#999' }}>{f.eq_id}</div>
                      </div>
                      <div style={{ flex: 1.6, fontSize: 12, color: '#222' }}>{f.service}</div>
                      <div style={{ flex: 1, textAlign: 'center', fontSize: 12, color: '#222' }}>{f.assigned}</div>
                      <div style={{ flex: 1, textAlign: 'center' }}>
                        {f.isOverdue ? (
                          <Tooltip title={`${f.daysOverdue} day${f.daysOverdue === 1 ? '' : 's'} overdue`}>
                            <span style={{ fontSize: 12, fontWeight: 600, color: '#222', cursor: 'default' }}>{f.time}</span>
                          </Tooltip>
                        ) : (
                          <span style={{ fontSize: 12, fontWeight: 600, color: '#222' }}>{f.time}</span>
                        )}
                      </div>
                      <div style={{ width: 60, textAlign: 'right' }}>
                        <Button
                          size="small"
                          style={{ background: 'rgba(14, 93, 146, 0.95)', color: '#fff', borderColor: 'rgba(14, 93, 146, 0.95)' }}
                          onClick={() => navigate(`/enquiry/edit/${f.eq_id}`)}
                        >
                          Open
                        </Button>
                      </div>
                    </div>
                  ))
                )}
              </div>
              {followUpDueList.length > 3 && (
                <div style={{ textAlign: 'center', marginTop: 8 }}>
                  <Button
                    type="link"
                    onClick={() => navigate('/enquiry/follow-ups-due', { state: { list: followUpDueList } })}
                    style={{ fontSize: 12, fontWeight: 600 }}
                  >
                    View Full Report
                  </Button>
                </div>
              )}
            </Card>
          </Col>

          {/* Right half — empty for now, add Sales Executive Performance here later */}
          {/* Sales Executive Performance */}
          <Col xs={24} lg={8}>
            <Card style={{ borderRadius: 10, height: '100%' }} bodyStyle={{ padding: '8px 12px' }}>
              {(() => {
                const calcRevenueFromInvoices = (name) => {
                  return invoices
                    .filter((inv) => {
                      const names = (inv.sales_executive || "").split(",").map(s => s.trim()).filter(Boolean);
                      if (names.includes(name)) return true;
                      if (names.length === 0 && inv.added_by) {
                        const resolvedName = userMap[String(inv.added_by).trim()];
                        return resolvedName === name;
                      }
                      return false;
                    })
                    .reduce((sum, inv) => {
                      const collected = (inv.payments || []).reduce((s, p) => s + Number(p.paid_amt || 0), 0);
                      return sum + collected;
                    }, 0);
                };

                const calcWonDealsFromQuotations = (name) => {
                  return quotations
                    .filter((q) => (q.quotation_status || "").toLowerCase() === "converted")
                    .filter((q) => {
                      const names = (q.assigned_to || "").split(",").map(s => s.trim()).filter(Boolean);
                      if (names.includes(name)) return true;
                      if (names.length === 0 && q.added_by) {
                        const resolvedName = userMap[String(q.added_by).trim()];
                        return resolvedName === name;
                      }
                      return false;
                    })
                    .length;
                };

                let execNames = [];
                if (viewAll) {
                  const set = new Set();
                  segData.forEach(d => {
                    const assignedNames = (d.assigned_to || "").split(',').map(s => s.trim()).filter(Boolean);
                    assignedNames.forEach(n => set.add(n));
                    if (assignedNames.length === 0) {
                      const creatorName = userMap[String(d.addedby ?? "").trim()];
                      if (creatorName && salesExecNames.includes(creatorName)) set.add(creatorName);
                    }
                  });
                  execNames = [...set];
                } else {
                  const user = JSON.parse(localStorage.getItem("ome_user") || "{}");
                  const userName = user?.name || user?.user_name || "";
                  execNames = userName ? [userName] : [];
                }

                const execs = execNames.map(name => {
                  const rows = segData.filter(d => {
                    const assignedNames = (d.assigned_to || "").split(',').map(s => s.trim()).filter(Boolean);
                    const isAssigned = assignedNames.includes(name);
                    const isCreator = assignedNames.length === 0 &&
                      salesExecNames.includes(name) &&
                      userMap[String(d.addedby ?? "").trim()] === name;
                    return isAssigned || isCreator;
                  });

                  const totalLeads = rows.length;
                  const wonDeals = calcWonDealsFromQuotations(name);
                  const revenue = calcRevenueFromInvoices(name);
                  const conversion = totalLeads ? ((wonDeals / totalLeads) * 100).toFixed(2) : "0.00";

                  return { name, totalLeads, wonDeals, revenue, conversion };
                }).sort((a, b) => b.totalLeads - a.totalLeads);

                if (!execNames.length) return <Typography.Text type="secondary" style={{ fontSize: 12 }}>No user info found</Typography.Text>;

                const colors = ['#1677ff', '#52c41a', '#722ed1', '#fa8c16', '#13c2c2', '#eb2f96'];

                return (
                  <>
                    <Typography.Text strong>Sales Executive Performance</Typography.Text>
                    <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 11, color: '#999', padding: '8px 4px 4px', borderBottom: '1px solid #f0f0f0' }}>
                      <span style={{ flex: 2 }}>Executive</span>
                      <span style={{ flex: 1, textAlign: 'center' }}>Total Leads</span>
                      <span style={{ flex: 1, textAlign: 'center' }}>Won Deals</span>
                      <span style={{ flex: 1.5, textAlign: 'center' }}>Revenue</span>
                      <span style={{ flex: 1, textAlign: 'center' }}>conversion</span>
                    </div>
                    <div style={{ maxHeight: 220, overflowY: 'auto' }}>
                      {execs.slice(0, 3).map((ex, idx) => (
                        <div key={ex.name} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '6px 4px', borderBottom: '1px solid #f5f5f5' }}>
                          <div style={{ display: 'flex', alignItems: 'center', gap: 8, flex: 2 }}>
                            <div style={{ width: 28, height: 28, borderRadius: '50%', background: '#f0f7ff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 12, color: colors[idx % colors.length], fontWeight: 700, flexShrink: 0 }}>
                              {ex.name.charAt(0).toUpperCase()}
                            </div>
                            <span style={{ fontSize: 12, fontWeight: 600, color: '#222' }}>{ex.name}</span>
                          </div>
                          <span style={{ flex: 1, textAlign: 'center', fontSize: 12, fontWeight: 700, color: '#1677ff' }}>{ex.totalLeads}</span>
                          <span style={{ flex: 1, textAlign: 'center', fontSize: 12, fontWeight: 700, color: '#52c41a' }}>{ex.wonDeals}</span>
                          <span style={{ flex: 1.5, textAlign: 'center', fontSize: 12, fontWeight: 700, color: '#722ed1' }}>₹{ex.revenue.toLocaleString('en-IN')}</span>
                          <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
                            <span style={{ fontSize: 11, fontWeight: 700, color: '#fa8c16' }}>{ex.conversion}%</span>
                            <div style={{ width: 50, height: 4, background: '#f0f0f0', borderRadius: 2 }}>
                              <div style={{ width: `${Math.min(parseFloat(ex.conversion), 100)}%`, height: '100%', background: '#fa8c16', borderRadius: 2 }} />
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                    {viewAll && execs.length >= 1 && (
                      <div style={{ textAlign: 'center', marginTop: 8 }}>
                        <Button type="link" style={{ fontSize: 12, fontWeight: 600 }} onClick={() => navigate('/enquiry/sales-performance')}>View Full Report</Button>
                      </div>
                    )}
                  </>
                );
              })()}
            </Card>
          </Col>



          <Col xs={24} lg={8}>
            <Card style={{ borderRadius: 10, height: '100%' }} bodyStyle={{ padding: '8px 12px' }}>
              <Typography.Text strong>Recent Activities</Typography.Text>
              {(() => {
                const user = JSON.parse(localStorage.getItem("ome_user") || "{}");
                const userName = user?.name || user?.user_name || "";

                const sourceRows = viewAll
                  ? segData
                  : segData.filter(d => d.assigned_to?.split(',').map(s => s.trim()).includes(userName));

                // Build activity entries — one per event (created + updated as separate rows)
                const activityRows = [];
                sourceRows.forEach(d => {
                  const status = d.eq_status?.trim() || "";
                  let color = '#722ed1'; let title = status || "Enquiry Updated";
                  if (status.toLowerCase().includes("quotation")) { color = '#1677ff'; title = "Quotation Sent"; }
                  else if (wonStatuses.includes(status)) { color = '#52c41a'; title = "Lead Converted"; }
                  else if (status.toLowerCase().includes("follow")) { color = '#fa8c16'; title = "Follow-up Call"; }
                  // single-actor resolver: never show comma-joined names
                  const firstName = (v) => (v || "").split(',')[0]?.trim() || "";

                  // Created event
                  if (d.eq_date) {
                    activityRows.push({
                      time: dayjs(d.eq_date).valueOf(),
                      timeStr: dayjs(d.eq_date).format("DD-MM hh:mm A"),
                      color: '#13c2c2',
                      title: "New Enquiry Created",
                      sub: `${d.eq_id} - ${d.name || "-"}`,
                      by: firstName(d.addedby) || firstName(d.assigned_to),
                    });
                  }
                  // Status-change events — one row per history entry
                  const history = Array.isArray(d.status_history)
                    ? d.status_history
                    : (() => { try { return JSON.parse(d.status_history || "[]"); } catch { return []; } })();

                  if (history.length) {
                    history.forEach(h => {
                      const st = (h.status || "").trim();
                      if (!st) return;
                      let c = '#722ed1'; let t = st;
                      if (st.toLowerCase().includes("quotation")) { c = '#1677ff'; t = "Quotation Sent"; }
                      else if (wonStatuses.includes(st)) { c = '#52c41a'; t = "Lead Converted"; }
                      else if (st.toLowerCase().includes("follow")) { c = '#fa8c16'; t = "Follow-up Call"; }
                      else if (st.toLowerCase().includes("demo")) { c = '#13c2c2'; t = "Demo Scheduled"; }
                      if (!h.updated_on) return;
                      activityRows.push({
                        time: dayjs(h.updated_on).valueOf(),
                        timeStr: dayjs(h.updated_on).format("DD-MM hh:mm A"),
                        color: c,
                        title: t,
                        sub: `${d.eq_id} - ${d.name || "-"}`,
                        by: firstName(h.by) || firstName(d.assigned_to),
                      });
                    });
                  } else if (d.enquiry_updated_on && d.enquiry_updated_on !== d.eq_date) {
                    activityRows.push({
                      time: dayjs(d.enquiry_updated_on).valueOf(),
                      timeStr: dayjs(d.enquiry_updated_on).format("DD-MM hh:mm A"),
                      color,
                      title,
                      sub: `${d.eq_id} - ${d.name || "-"}`,
                      by: firstName(d.assigned_to),
                    });
                  }
                });

                const visibleRows = viewAll
                  ? activityRows
                  : activityRows.filter(a => (a.by || "").trim() === userName.trim());

                const activities = visibleRows
                  .sort((a, b) => b.time - a.time)
                  .slice(0, 4);

                if (!activities.length) {
                  return <div style={{ marginTop: 10 }}><Typography.Text type="secondary" style={{ fontSize: 12 }}>No recent activities</Typography.Text></div>;
                }

                return (
                  <div style={{ marginTop: 12, position: 'relative' }}>
                    {activities.map((a, i) => (
                      <div key={i} style={{ display: 'flex', gap: 12, position: 'relative', paddingBottom: i < activities.length - 1 ? 7 : 0 }}>
                        <div style={{ fontSize: 11, color: '#999', minWidth: 70, flexShrink: 0, textAlign: 'left', paddingTop: 1 }}>{a.timeStr}</div>

                        <div style={{ position: 'relative', display: 'flex', flexDirection: 'column', alignItems: 'center', flexShrink: 0 }}>
                          <span style={{ width: 10, height: 10, borderRadius: '50%', background: a.color, zIndex: 1, marginTop: 3 }} />
                          {i < activities.length - 1 && (
                            <span style={{ position: 'absolute', top: 13, bottom: -16, width: 2, background: '#eee' }} />
                          )}
                        </div>

                        <div style={{ flex: 1 }}>
                          <div style={{ fontSize: 12, fontWeight: 600, color: '#222' }}>{a.title}</div>
                          <div style={{ fontSize: 11, color: '#999', display: 'flex', alignItems: 'center', gap: 6, flexWrap: 'wrap' }}>
                            <span>{a.sub}</span>
                            {viewAll && a.by && <span style={{ color: '#1677ff', fontWeight: 600 }}>· {a.by}</span>}
                          </div>
                        </div>
                      </div>
                    ))}
                    {activities.length >= 4 && (
                      <div style={{ textAlign: 'center', marginTop: 6 }}>
                        <Button type="link" style={{ fontSize: 12, fontWeight: 600, padding: 0 }}>View All Activities</Button>
                      </div>
                    )}
                  </div>
                );
              })()}
            </Card>
          </Col>
        </Row>
      </div>

      <div id="enquiry-table-section" style={{ padding: '0 16px' }}>
        <Divider style={{ margin: '8px 0' }} />

        <Card style={{ marginBottom: 8 }} bodyStyle={{ padding: 12 }}>
          <Row gutter={[8, 8]} align="middle">
            <Col flex="280px">
              <Input

                allowClear
                placeholder="Search Enquiries..."
                value={searchText}
                onChange={(e) => { setSearchText(e.target.value); applyAllFilters(e.target.value, "", dateRange, dateFilterType, statusFilter, sourceFilter); }}
              />
            </Col>
            <Col>
              <Select
                allowClear placeholder="All Status" style={{ minWidth: 130 }}
                value={statusFilter}
                options={allStatusConfig.map(s => ({ label: s.label, value: s.label }))}
                onChange={(val) => { setStatusFilter(val); applyAllFilters(searchText, "", dateRange, dateFilterType, val, sourceFilter); }}
              />
            </Col>
            <Col>
              <Select
                allowClear placeholder="All Services" style={{ minWidth: 140 }}
                options={serviceOptions}
                onChange={(val) => applyAllFilters(searchText, val || "", dateRange, dateFilterType, statusFilter, sourceFilter)}
              />
            </Col>
            <Col>
              <Select
                allowClear placeholder="All Sources" style={{ minWidth: 130 }}
                value={sourceFilter}
                options={[...new Set(segData.map(d => d.eq_source).filter(Boolean))].map(s => ({ label: s, value: s }))}
                onChange={(val) => { setSourceFilter(val); applyAllFilters(searchText, "", dateRange, dateFilterType, statusFilter, val); }}
              />
            </Col>


            <Col>
              <Select
                value={dateFilterType} style={{ minWidth: 150 }}
                onChange={(val) => { setDateFilterType(val); applyAllFilters(searchText, "", dateRange, val, statusFilter, sourceFilter); }}
                options={[
                  { label: "Next Follow-up", value: "Next Follow Up" },
                  { label: "Added On", value: "eq_date" },
                  { label: "Updated On", value: "enquiry_updated_on" },
                ]}
              />
            </Col>
            <Col>
              <DatePicker.RangePicker
                value={dateRange}
                format="DD-MM-YYYY"
                onChange={(range) => { setDateRange(range); applyAllFilters(searchText, "", range, dateFilterType, statusFilter, sourceFilter); }}
              />
            </Col>
            <Col>
              <Select
                value={draftFilter}
                style={{ minWidth: 120 }}
                onChange={(val) => applyDraftFilter(val)}
                options={[
                  { label: "All", value: null },
                  { label: "Draft", value: true },
                ]}
              />
            </Col>
   <Col>
              <Button onClick={clearDateFilters}>Clear</Button>
            </Col>
            <Col>
              <Dropdown menu={{ items: exportMenuItems }} placement="bottomRight">
                <Button icon={<DownloadOutlined />}>Export</Button>
              </Dropdown>
            </Col>
          </Row>
        </Card>



        {/* Enquiry Table */}
        <Table
          columns={columns}
          dataSource={data}
          pagination={true}
          expandable={{
            expandedRowRender,
            expandedRowKeys,
            onExpandedRowsChange: setExpandedRowKeys,
            expandIcon: () => null,
          }}
          scroll={{ x: 'max-content' }}
        />

        {msgContext}
        <Drawer
          title={
            <Space align="center">
              <Title level={4} style={{ margin: 0 }}>
                {editingRecord ? 'Edit Enquiry' : 'Add Enquiry'}
              </Title>
              <Text
                strong
                style={{
                  color: 'darkviolet',
                  fontSize: '1.1rem',
                  padding: '2px 8px',
                  background: '#f3e8ff',
                  borderRadius: '8px',
                  fontWeight: 700,
                }}
              >
                {editingRecord ? editingRecord.eq_id : generatedEQNo}
              </Text>
            </Space>
          }
          width={1000}
          open={drawerOpen}
          onClose={() => setDrawerOpen(false)}
          destroyOnClose
        >
          <CreateEnquiry
            initialValues={editingRecord}
            onSubmit={handleSubmit}
            onCancel={() => setDrawerOpen(false)}
            handleEQNo={setGeneratedEQNo}
          />
        </Drawer>
      </div>
    </Card>
  );
};

export default EnquiryPage;
